import { GatsbyImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from 'react';
import ProductServices from '../../../services/product-services';
import Button from '../../../shared/components/atoms/button/button';
import HeartRating from '../../../shared/components/atoms/heart-rating/heart-rating';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import { localStorage } from '../../../shared/utils/storage';
import './section-other-recommendations.scss';

const SectionOtherRecommendations = ({ contentInfo }) => {

    const { homeLink } = useHomeLinkMode();
    const [allProductsRating, setAllProductsRating] = useState(null)

    useEffect(() => {
        getRating()
    }, []);

    function getRating() {
        const tokenInfo = localStorage.getItem("TOKEN_INFO") ? localStorage.getItem("TOKEN_INFO") : null
        let config = {
            headers: {
                Authorization: tokenInfo ? tokenInfo.idToken : null,
            },
        }

        const payload = process.env.COUNTRY_CODE

        ProductServices.allRateProduct(tokenInfo ? config : null, payload).then(
            response => {
                if (response.status === 200) {
                    setAllProductsRating(response.data ? response.data : null)
                } else {
                    setAllProductsRating(null)
                }
            }
        )

    }

    return (
        <section className="f-m-other-recommendations">
            <div className="f-m-other-recommendations__content">
                <h2 className="f-m-other-recommendations__title">
                    {contentInfo.tituloOtrasRecomendaciones}
                </h2>
                <div className="f-m-other-recommendations__recommendation-box">
                    <div className="f-m-other-recommendations__cards-container">
                        {contentInfo.otrasRecomendaciones &&
                            contentInfo.otrasRecomendaciones.map((info, index) => {

                                function filterById(obj) {
                                    if (obj.productId === info.idDelProducto) {
                                        return true
                                    }
                                }
                                const productRating = allProductsRating && allProductsRating.filter(filterById).filter(Boolean)
                                
                                return (
                                    <div key={index}
                                        className="f-m-other-recommendations__single-card" onClick={() => { location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "productos/") + info.categoria[0].idCategoria + info.slug }}>
                                        <div className="f-m-other-recommendations__card">
                                            <div className="f-m-other-recommendations__card-content">
                                                {info.imagenProducto && info.imagenProducto[0] &&
                                                    <GatsbyImage
                                                        className="f-m-other-recommendations__card-image"
                                                        image={info.imagenProducto[0].gatsbyImageData}
                                                        alt={info.imagenProducto[0].description}
                                                    />
                                                }
                                                <div className="f-m-other-recommendations__card-info">
                                                    <p className="f-m-other-recommendations__category">{info.categoria[0].nombreDeLaCategoria}</p>
                                                    <h3 className="f-m-other-recommendations__name">{info.nombreProducto}</h3>
                                                    <div className="f-m-other-recommendations__rate">
                                                        <HeartRating
                                                            rate={productRating !== null && productRating[0] !== undefined ? (productRating[0].userRate ? productRating[0].rate : productRating[0].averageRate) : (info.ratingValue ? info.ratingValue : 0)}
                                                            ratingsNumber={productRating !== null && productRating[0] !== undefined ? productRating[0].countRate : (info.reviewCount ? info.reviewCount : 0)}
                                                            readOnly={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <Button
                    id="f-a-button__other-recommendations"
                    className="f-a-button__primary-blue f-a-button__extra-big"
                    copy={"Todos los productos"}
                    arrow={true}
                    onclick={() => location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "productos/") + "todos-los-productos/"}
                />
            </div>
        </section>
    )
}

export default SectionOtherRecommendations
